/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Premium_Thats_JustInputs */

const en_premium_thats_just = /** @type {(inputs: Premium_Thats_JustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That's just:`)
};

const es_premium_thats_just = /** @type {(inputs: Premium_Thats_JustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son solo:`)
};

/**
* | output |
* | --- |
* | "That's just:" |
*
* @param {Premium_Thats_JustInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const premium_thats_just = /** @type {((inputs?: Premium_Thats_JustInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_Thats_JustInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_premium_thats_just(inputs)
	return en_premium_thats_just(inputs)
});